export default __webpack_public_path__ + "static/media/trashTab.7ca2b020.svg";